<app-refrigerator-toggale [value]="isRefrigerated()" (toggle)="isRefrigerated.set($event)" />
<div class="grid grid-cols-1 gap-x-6 gap-y-5 md:grid-cols-2">
  <div class="flex flex-col gap-1.5">
    <label class="labelColorText text-sm font-semibold">
      <span i18n="@@subProduct.field.titleEn">Title (English)</span>
    </label>
    <input
      type="text"
      formControlName="titleEn"
      readonly
      i18n-placeholder="@@subProduct.placeholder.titleEn"
      placeholder="Auto-generated from attributes"
      class="w-full cursor-not-allowed rounded-lg border border-gray-200 bg-gray-100 px-3 py-2.5 text-sm text-gray-600 outline-none"
      [class.bordererrorcolor]="invalid('titleEn')" />
  </div>

  <div class="flex flex-col gap-1.5">
    <label class="labelColorText text-sm font-semibold">
      <span i18n="@@subProduct.field.titleAr">Title (Arabic)</span>
      <span class="errortextcolor">*</span>
    </label>
    <input
      type="text"
      formControlName="titleAr"
      readonly
      dir="rtl"
      i18n-placeholder="@@subProduct.placeholder.titleEn"
      placeholder="Auto-generated from attributes"
      class="w-full cursor-not-allowed rounded-lg border border-gray-200 bg-gray-100 px-3 py-2.5 text-sm text-gray-600 outline-none" />
  </div>

  <div class="flex flex-col gap-1.5 md:col-span-2">
    <label class="labelColorText text-sm font-semibold" i18n="@@subProduct.field.descEn">Description (English)</label>
    <textarea
      formControlName="descriptionEn"
      rows="3"
      i18n-placeholder="@@subProduct.placeholder.descEn"
      placeholder="Enter description in English"
      class="focus:borderPrimaryColor w-full resize-none rounded-lg border border-gray-200 px-3 py-2.5 text-sm transition outline-none focus:ring-2 focus:ring-blue-50"
      [class.bordererrorcolor]="invalid('descriptionEn')"></textarea>

    @if (err("descriptionEn", "maxlength")) {
      <span class="errortextcolor text-xs" i18n="@@subProduct.validation.descMaxLength">
        Description cannot exceed 2000 characters
      </span>
    } @else if (err("descriptionEn", "englishCharacters")) {
      <span class="errortextcolor text-xs" i18n="@@product.validation.shouldBeEnglishDescription">
        English description must contain valid english characters
      </span>
    }
  </div>

  <div class="flex flex-col gap-1.5 md:col-span-2">
    <label class="labelColorText text-sm font-semibold" i18n="@@subProduct.field.descAr">Description (Arabic)</label>
    <textarea
      formControlName="descriptionAr"
      rows="3"
      dir="rtl"
      i18n-placeholder="@@subProduct.placeholder.descAr"
      placeholder="Enter description in Arabic"
      class="focus:borderPrimaryColor w-full resize-none rounded-lg border border-gray-200 px-3 py-2.5 text-sm transition outline-none focus:ring-2 focus:ring-blue-50"
      [class.bordererrorcolor]="invalid('descriptionAr')"></textarea>

    @if (err("descriptionAr", "maxlength")) {
      <span class="errortextcolor text-xs" i18n="@@subProduct.validation.descMaxLength">
        Description cannot exceed 2000 characters
      </span>
    } @else if (err("descriptionAr", "arabicCharacters")) {
      <span class="errortextcolor text-xs" i18n="@@product.validation.shouldBeArabicDescription">
        Arabic description must contain valid arabic characters
      </span>
    }
  </div>

  <div class="flex flex-col gap-1.5">
    <label class="labelColorText text-sm font-semibold" i18n="@@subProduct.field.category">Category</label>
    <div class="relative">
      <select
        formControlName="category"
        [class.textPlaceholderColor]="!form.get('category')?.value"
        class="bgWhiteColor focus:borderPrimaryColor w-full appearance-none rounded-lg border border-gray-200 px-3 py-2.5 text-sm transition outline-none focus:ring-2 focus:ring-blue-50"
        [class.pr-3]="!isArabic()"
        [class.pl-8]="!isArabic()"
        [class.pl-3]="isArabic()"
        [class.pr-8]="isArabic()">
        <option value="" i18n="@@subProduct.placeholder.category">Select category</option>
        @for (cat of localCategories(); track cat.id) {
          <option [value]="cat.id" class="text-gray-900">{{ isArabic() ? cat.titleAr : cat.titleEn }}</option>
        }
      </select>
      <app-dropdown-arrow [isArabic]="isArabic()" />
    </div>
  </div>

  <div class="flex flex-col gap-1.5">
    <label class="labelColorText text-sm font-semibold">
      <span i18n="@@subProduct.field.subCategory">Sub Category</span>
      @if (loadingSubs()) {
        <span class="animate-pulse text-xs text-blue-500">(Loading...)</span>
      }
    </label>
    <div class="relative">
      <select
        formControlName="subCategory"
        [class.textPlaceholderColor]="!form.get('subCategory')?.value"
        class="bgWhiteColor focus:borderPrimaryColor w-full appearance-none rounded-lg border border-gray-200 px-3 py-2.5 text-sm transition outline-none focus:ring-2 focus:ring-blue-50"
        [class.pr-3]="!isArabic()"
        [class.pl-8]="!isArabic()"
        [class.pl-3]="isArabic()"
        [class.pr-8]="isArabic()">
        <option value="" i18n="@@subProduct.placeholder.subCategory">Select sub category</option>
        @for (sub of localSubCategories(); track sub.id) {
          <option [value]="sub.id" class="text-gray-900">{{ isArabic() ? sub.titleAr : sub.titleEn }}</option>
        }
      </select>
      <app-dropdown-arrow [isArabic]="isArabic()" />
    </div>
  </div>

  <div class="flex flex-col gap-1.5 md:col-span-2">
    <label class="labelColorText text-sm font-semibold" i18n="@@subProduct.field.barcode">Barcode</label>
    <input
      type="text"
      formControlName="barcode"
      maxlength="13"
      i18n-placeholder="@@subProduct.placeholder.barcode"
      placeholder="Enter barcode (EAN-13)"
      class="focus:borderPrimaryColor w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm transition outline-none"
      [class.bordererrorcolor]="invalid('barcode')" />

    @if (err("barcode", "backendError")) {
      <span class="errortextcolor text-xs">{{ form.get("barcode")?.getError("backendError") }}</span>
    }
  </div>
</div>
